export const validatorOptions = {
  allow_utf8_local_part: false,
};
